import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import TestimonialForm from '../components/TestimonialForm';

export default function Testimonials() {
	return (
		<div style={{ background: 'var(--color-bg)' }}>
			<Navbar />

			<div style={{ paddingTop: 80 }}>
				<div className="testimonials-layout" style={{ display: 'grid', gridTemplateColumns: '1fr 2.7fr', minHeight: '80vh' }}>

					{/* Left — info */}
					<div className="testimonials-info-panel" style={{ padding: '48px 32px', background: 'var(--color-surface-alt)' }}>
						<h1 style={{
							fontFamily: 'var(--font-display)',
							fontSize: '24px',
							fontWeight: 400,
							color: 'var(--color-text)',
							marginBottom: 24,
							lineHeight: 1.3
						}}>
							Share Your Experience
						</h1>

						<img
							src="/assets/instagram-avatar.jpg"
							alt="Bhagyashree Dhavalshankh"
							style={{
								width: 122,
								height: 122,
								borderRadius: '50%',
								objectFit: 'cover',
								marginLeft: 100,
								marginBottom: 20,
								display: 'block'
							}}
						/>

						<p style={{
							fontSize: 14,
							color: 'var(--color-text)',
							marginBottom: 16,
							fontFamily: 'var(--font-body)',
							lineHeight: 1.6
						}}>
							Your feedback means the world to me and helps others make their decision.
						</p>

						<p style={{
							fontSize: 14,
							color: 'var(--color-muted)',
							marginBottom: 10,
							fontFamily: 'var(--font-body)'
						}}>
							📧 framesbybhagya@gmail.com
						</p>

						<p style={{
							fontSize: 14,
							color: 'var(--color-muted)',
							marginBottom: 10,
							fontFamily: 'var(--font-body)',
							display: 'flex',
							alignItems: 'center'
						}}>
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: 6, flexShrink: 0 }}>
								<defs>
									<linearGradient id="instagramGradient" x1="0%" y1="100%" x2="100%" y2="0%">
										<stop offset="0%" style={{ stopColor: '#FD5949', stopOpacity: 1 }} />
										<stop offset="50%" style={{ stopColor: '#D6249F', stopOpacity: 1 }} />
										<stop offset="100%" style={{ stopColor: '#285AEB', stopOpacity: 1 }} />
									</linearGradient>
								</defs>
								<rect x="2" y="2" width="20" height="20" rx="5" ry="5" stroke="url(#instagramGradient)"></rect>
								<path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" stroke="url(#instagramGradient)"></path>
								<line x1="17.5" y1="6.5" x2="17.51" y2="6.5" stroke="url(#instagramGradient)"></line>
							</svg>
							@framesbybhagya
						</p>

						<p style={{
							fontSize: 14,
							color: 'var(--color-muted)',
							marginBottom: 10,
							fontFamily: 'var(--font-body)'
						}}>
							📍 Pune, Maharashtra
						</p>

						<p style={{
							fontFamily: 'var(--font-display)',
							fontSize: 14,
							fontStyle: 'italic',
							color: 'var(--color-text)',
							marginTop: 32,
							lineHeight: 1.7
						}}>
							"Your words inspire me to keep capturing beautiful moments. Thank you for sharing your story."
						</p>
					</div>

					{/* Right — form */}
					<div className="testimonials-form-panel" style={{ padding: '48px 40px', background: 'var(--color-surface)' }}>
						<h2 style={{
							fontFamily: 'var(--font-display)',
							fontSize: '20px',
							fontWeight: 400,
							color: 'var(--color-text)',
							marginTop: 0,
							marginBottom: 24
						}}>
							Leave a Testimonial
						</h2>
						<p style={{
							fontSize: 14,
							color: 'var(--color-muted)',
							marginBottom: 32,
							fontFamily: 'var(--font-body)'
						}}>
							Share your experience and help others discover the magic of professional photography. Your testimonial will be published immediately on our home page.
						</p>
						<TestimonialForm />
					</div>

				</div>
			</div>

			<Footer />
		</div>
	);
}
